import effectiveCommunication from "../../translations/pl_PL/blog/effectiveCommunication.json";
import { PUT_DATA_BLOG } from '../Blog/action';

function knowladgeEffectiveCommunicationReducer(
  state = effectiveCommunication,
  action
) {
  switch (action.type) {
    case PUT_DATA_BLOG:
      {
        if (action.meta === "effectiveCommunication") {
          return action.payload;
        } else { 
          return state }
      }

    default:
      return state;
  }
}

export default knowladgeEffectiveCommunicationReducer;
